import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {
  useRoute,
} from 'vue-router';
import CommonHeader from '@/components/NavBar/CommonHeader.vue';
import DashboardHeader from '@/components/NavBar/DashboardHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {


const route = useRoute();


return (_ctx: any,_cache: any) => {
  return (_unref(route).name === 'Dashboard')
    ? (_openBlock(), _createBlock(DashboardHeader, {
        key: 0,
        class: "navbar"
      }))
    : (_openBlock(), _createBlock(CommonHeader, { key: 1 }))
}
}

})